import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  StockCountNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  StockCount as StockCountEntity,
  StockCountStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import StockCountModel from "../../data/model/StockCount";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const listOptions = `
  options: { 
    limit: $limit, page: $page, 
    sort: { updatedAt: DESC },
    filter: { 
      updatedAt: {after: $after}, 
      status: {
        notEq: $status
      }
    }
    filterOperator: AND
    includeDeleted: true
  }
`;

const listVariables = `
  $after: DateTime,
  $page: Int,
  $limit: Int,
  $status: String
`;

const stockCountsQuery = gql`
  ${StockCountNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
    query GetStockCounts(${listVariables}) {
        stockCounts(${listOptions}) {
            items {
              ...StockCountNoNesting
            }
            meta {
              ...PaginatedListMetaNoNesting
            }
        }
    }
`;

export const stockCountDefinition = new EntityResourceDefinition<
  StockCountEntity,
  StockCountModel
>({
  entity: "stock_counts",
  query: stockCountsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity._raw.id = fetchedEntity.id;
    newEntity.name = fetchedEntity.name;
    newEntity.retailerStocktakeId = fetchedEntity.retailerStocktakeId ?? null;
    newEntity.status = fetchedEntity.status;
    newEntity.location.id = fetchedEntity.locationId;
    newEntity.source = fetchedEntity.source;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "stockCounts", stockCountsQuery, {
      ...options,
      additionalVariables: {
        status: StockCountStatus.COMPLETE,
      },
    });
  },
});
